module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Bold.7813f758.eot";